import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import Item from '../../Item/Item';
import styles from './TableViewer.module.css';

const TableViewer = ({ data }) => {
  const [dataToShow, setDataToShow] = useState([]);
  // console.log("🚀 ~ TableViewer ~ dataToShow:", dataToShow)

  useEffect(() => {
    if (data) {
      const itemsToRemove = data.products.length % 2;

      if (itemsToRemove > 0) {
        const newData = data.products.slice(0, data.products.length - itemsToRemove);
        setDataToShow(newData);
      } else {
        setDataToShow(data.products);
      }
    }
  }, [data]);

  return (
    <div className={styles.table}>
      {dataToShow?.map((product) => (
        <Item key={product.id} center data={product} />
      ))}
    </div>
  );
};

TableViewer.propTypes = {
  data: PropTypes.object
};

export default TableViewer;
